module.exports = __webpack_public_path__ + "img/water_bottle.bc0313ae.jpg";